import { Quote } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const STORY_IMAGE =
  "https://images.unsplash.com/photo-1758687127068-816ae9b29c0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2NzV8MHwxfHNlYXJjaHwyfHxfYXRoZXIlMjBhbmQlMjBzb24lMjByZWFkaW5nJTIwdG9nZXRoZXIlMjBib29rJTIwaG9tZXxlbnwwfHx8fDE3ODc5MjkyOTh8MA&ixlib=rb-4.1.0&q=85";

export default function Story() {
  return (
    <section id="story" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32" aria-labelledby="story-heading">
      <span id="story-heading" className="sr-only">The story behind VoiceLens AI</span>
      <div className="grid items-center gap-14 lg:grid-cols-2">
        <div>
          <SectionHeading
            eyebrow={{ index: "03", label: "My Story" }}
            title={<>Built From <span className="text-glow-gradient">Personal Experience</span></>}
          />
          <Reveal delay={0.15}>
            <div className="relative mt-8 rounded-3xl border-l-4 border-[#00D4FF] bg-[#0C2340]/60 p-7 sm:p-9" data-testid="story-quote-card">
              <Quote className="absolute -top-5 left-6 h-10 w-10 rounded-full bg-[#071A35] p-2 text-[#00D4FF]" aria-hidden="true" />
              <p className="text-base leading-relaxed text-slate-200 sm:text-lg">
                I built VoiceLens AI after losing much of my own vision to macular degeneration —
                while raising a son with dyslexia. We faced different challenges but the same
                frustration: important information was right in front of us, yet accessing and
                understanding it wasn't always easy.
              </p>
              <p className="mt-5 text-base leading-relaxed text-slate-200 sm:text-lg">
                VoiceLens AI was created to help people regain independence through AI-powered
                reading and understanding.
              </p>
              <footer className="mt-7 flex items-center gap-4">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-[#2563EB] to-[#00D4FF] font-display text-lg font-black text-white" aria-hidden="true">
                  F
                </span>
                <div>
                  <p className="font-display font-bold text-white">The Founder</p>
                  <p className="text-sm text-slate-400">Next Wave Essentials LLC</p>
                </div>
              </footer>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <div className="relative" data-testid="story-photo">
            <div
              className="absolute -inset-4 rounded-[2rem] bg-[radial-gradient(circle_at_30%_20%,rgba(0,212,255,0.18),transparent_60%)] blur-xl"
              aria-hidden="true"
            />
            <div className="relative overflow-hidden rounded-[2rem] border border-[#00D4FF]/25 shadow-[0_30px_70px_rgba(0,0,0,0.5)]">
              <img
                src={STORY_IMAGE}
                alt="A father and son reading a book together at home — the inspiration behind VoiceLens AI"
                className="aspect-[4/3] w-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#071A35]/85 via-transparent to-transparent" aria-hidden="true" />
              <p className="absolute bottom-5 left-6 right-6 text-sm font-medium text-slate-200">
                Every feature in VoiceLens AI began at a kitchen table like this one.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
